import { useMemo } from 'react'

export function useConst<T = unknown>(val: T): T {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => val, [])
}
